import { render, staticRenderFns } from "./InstituteJusticeDetail.vue?vue&type=template&id=1b4da926&scoped=true"
import script from "./InstituteJusticeDetail.vue?vue&type=script&lang=js"
export * from "./InstituteJusticeDetail.vue?vue&type=script&lang=js"
import style0 from "./InstituteJusticeDetail.vue?vue&type=style&index=0&id=1b4da926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4da926",
  null
  
)

export default component.exports